/**
 * Kleine bouwstenen voor werkvoorraden: statuspil en lege staat.
 * De kaart `WorkCard` is op 4 oktober 2026 verwijderd (knoppenmatrix K230: nergens gebruikt).
 */

import * as React from "react";
import "./pane.css";

export type PillTone = "ok" | "bad" | "open" | "done" | "info" | "flag";

export function Pill({
  tone,
  title,
  children,
}: {
  tone: PillTone;
  title?: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <span className={`pane-pill is-${tone}`} title={title}>
      {children}
    </span>
  );
}

/** Lege staat van een werkvoorraad of lijst. */
export function EmptyNotice({ children }: { children: React.ReactNode }): JSX.Element {
  return <div className="pane-empty">{children}</div>;
}
